module.exports = __webpack_public_path__ + "static/ecanta-cozumler-91c8e76f1a7108faf0377acce34ae5e1.png";